import { create } from 'zustand';

/** Users the signed-in user has blocked. */
interface BlocksState {
  ids: Record<string, true>;
  /** "<target key>:<author id>" pairs whose collapsed messages the user chose to show. */
  revealed: Record<string, true>;
  setAll: (ids: string[]) => void;
  set: (userId: string, blocked: boolean) => void;
  reveal: (key: string) => void;
  reset: () => void;
}

export const useBlocks = create<BlocksState>((set) => ({
  ids: {},
  revealed: {},
  reveal: (key) => set((s) => ({ revealed: { ...s.revealed, [key]: true } })),
  setAll: (ids) => set({ ids: Object.fromEntries(ids.map((id) => [id, true as const])) }),
  set: (userId, blocked) =>
    set((s) => {
      if (!!s.ids[userId] === blocked) return s;
      const ids = { ...s.ids };
      if (blocked) ids[userId] = true;
      else delete ids[userId];
      return { ids };
    }),
  reset: () => set({ ids: {}, revealed: {} }),
}));

export const useIsBlocked = (userId: string | null | undefined) => useBlocks((s) => !!userId && !!s.ids[userId]);
export const isBlocked = (userId: string | null | undefined) => !!userId && !!useBlocks.getState().ids[userId];
